import React from 'react'
import { Layout } from 'antd'
const { Header } = Layout

const ThankYouView = () => {
  return (
    <Layout>
      <section id="thank-you-view">
        <Header className="header">
          <a href="/joinus/login">
            <div className="header__logo" />
          </a>
        </Header>
        <content>
          <section id="thank-you-content">
            <div className="thank-you-note">
              <h1>
                Axiom acknowledges the reception of your application. Your
                profile will be reviewed on a regular basis and based on pre
                -selection screening, we will contact you for an interview.
              </h1>
            </div>
            <a href="/joinus/login">
              <p>Return to the login page</p>
            </a>
          </section>
        </content>
      </section>
    </Layout>
  )
}

export default ThankYouView
